import { Box, Grid, Modal } from "@mui/material";
import { FormOption } from "./component/DeliveryInformationForm/UserDetailForm/UserDetailForm";
import { AssetWithState } from "../AssetList/AssetList";
import React, { useMemo, useState } from "react";
import {
  LaptopReplacementStatesEnum,
  OptionValue,
  RequestStatusEnum,
} from "../../helper/constant";
import ResponseModal from "../../component/ResponseModal/ResponseModal";
import { LoadingAnimation } from "../Actions/LoadingAnimation/LoadingAnimation";
import LaptopRenewalForm from "./LaptopRenewalForm/LaptopRenewalForm";
import UserPreferenceSummary from "./UserPreferenceSummary/UserPreferenceSummary";
import DeferReplacementForm from "./DeferReplacementForm/DeferReplacementForm";

type Props = {
  currentAsset: AssetWithState;
  isModalOpen: boolean;
  handleCloseModal: () => void;
};

const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  padding: "32px",
  minWidth: "968px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export type LaptopRenewalFormValue = {
  deliveryLocation: FormOption;
  contactNumber: string;
  isBuyOldLaptop?: OptionValue | null;
};

const LaptopReplacementModal = ({
  currentAsset,
  isModalOpen,
  handleCloseModal,
}: Props) => {
  const [isAlertMessageOpen, setIsAlertMessageOpen] = useState(false);
  const [isAlertStatus, setIsAlertStatus] = useState<RequestStatusEnum>();
  const [isLoading, setIsLoading] = useState(false);
  const [isEditStatus, setIsEditStatus] = useState(false);
  const [isDeferReplacementModalOpen, setIsDeferReplacementModalOpen] =
    useState(false);
  const assetStatus = useMemo(() => currentAsset?.state, [currentAsset]);

  return (
    <>
      <LoadingAnimation isOpen={isLoading} />
      <ResponseModal
        isOpen={isAlertMessageOpen}
        status={isAlertStatus}
        onClose={() => setIsAlertMessageOpen(false)}
      />
      <Modal
        open={isModalOpen}
        onClose={() => {
          handleCloseModal();
        }}
        aria-labelledby="laptop-renewal-modal-title"
        aria-describedby="laptop-renewal-modal-description"
      >
        <Box sx={modalStyle}>
          <LoadingAnimation isOpen={isLoading} />
          <Grid container spacing={2}>
            {isDeferReplacementModalOpen ? (
              <DeferReplacementForm
                currentAsset={currentAsset}
                setLoadingStatus={setIsLoading}
                setIsAlertStatus={(val) => setIsAlertStatus(val)}
                setAlertMessageOpen={() => setIsAlertMessageOpen(true)}
                changeDeferReplacementModal={(val: boolean) =>
                  setIsDeferReplacementModalOpen(val)
                }
                handleCloseModal={handleCloseModal}
              />
            ) : (
              <>
                {assetStatus === LaptopReplacementStatesEnum.WAITING_RESPONSE ||
                isEditStatus ? (
                  <LaptopRenewalForm
                    currentAsset={currentAsset}
                    handleCloseModal={handleCloseModal}
                    setIsAlertStatus={(val) => setIsAlertStatus(val)}
                    setAlertMessageOpen={() => setIsAlertMessageOpen(true)}
                    setLoadingStatus={setIsLoading}
                    editStatus={isEditStatus}
                    openDeferReplacementModal={() =>
                      setIsDeferReplacementModalOpen(true)
                    }
                    changeEditStatus={setIsEditStatus}
                  />
                ) : (
                  <UserPreferenceSummary
                    currentAsset={currentAsset}
                    handleCloseModal={handleCloseModal}
                    changeEditStatus={setIsEditStatus}
                    setIsAlertStatus={(val) => setIsAlertStatus(val)}
                    setAlertMessageOpen={() => setIsAlertMessageOpen(true)}
                    setLoadingStatus={setIsLoading}
                  />
                )}
              </>
            )}
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default LaptopReplacementModal;
